import { setdata } from "../../../../../../../helpers/helpers";
import { fetchAllPackages } from "../../../../../../../services/ShipperServices/Packages/packages.services";
import { GridShell, GridTile, sizeSpec, useGridData, weightSpec } from "../Products/GridParts";
import { PackageIcon, packageUnits } from "../Products/LibraryCells";

// The Packages grid: one tile per package with its size and weight in the
// package's own unit, as the list shows them (page size, search, skeleton and
// footer from useGridData; the page size was a fixed 20). A click adds it as
// before.
export default function PackageGridView(props) {
  const { handlescrollpackage, setFilter, refresh } = props;
  const grid = useGridData({
    fetchPage: fetchAllPackages,
    refresh,
    setFilter,
    placeholder: "Filter Packages",
  });

  const tileSpecs = (data) => {
    const units = packageUnits(data);
    return [
      sizeSpec({ row: data, unit: units.size, kind: "package" }),
      weightSpec(setdata(() => data.weight, false, "0"), units.weight),
    ];
  };

  return (
    <GridShell grid={grid} emptyText="No Packages to display!">
      {grid.items.map((data, index) => (
        <GridTile
          key={data?.id ?? index}
          name={setdata(() => data.name, false, "")}
          photo={data?.file}
          icon={<PackageIcon />}
          specs={tileSpecs(data)}
          onClick={() => handlescrollpackage(data)}
        />
      ))}
    </GridShell>
  );
}
